import React from "react";
import { CircleUser, Phone } from "lucide-react";

/**
 * Shared contact card. Renders one or more shared contacts from
 * `message.metadata.contacts`. Each contact shows name + first phone, with a
 * tap-to-call link. Extra phones/contacts are summarised.
 */
const ContactMessage = ({ message }) => {
  const contacts = Array.isArray(message.metadata?.contacts)
    ? message.metadata.contacts
    : [];

  if (contacts.length === 0) {
    return <span className="wa-msg__text">{message.content || "👤 Contact"}</span>;
  }

  return (
    <div className="wa-msg__contact">
      {contacts.map((c, i) => {
        const primaryPhone = c.phones?.[0]?.phone || "";
        const extraPhones = (c.phones?.length || 0) - 1;
        return (
          <div className="wa-msg__contact-row" key={`${c.name}-${i}`}>
            <span className="wa-msg__contact-avatar">
              <CircleUser size={28} />
            </span>
            <span>
              <span className="wa-msg__contact-name">{c.name || "Unknown"}</span>
              {primaryPhone && (
                <a className="wa-msg__contact-phone" href={`tel:${primaryPhone}`}>
                  <Phone size={10} /> {primaryPhone}
                  {extraPhones > 0 && (
                    <span className="wa-msg__contact-extra"> +{extraPhones} more</span>
                  )}
                </a>
              )}
              {c.org && <span className="wa-msg__contact-extra"> · {c.org}</span>}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default ContactMessage;
